/** What ra-data-postgrest throws when PostgREST rejects a write. */
type PostgrestHttpError = {
  status?: number;
  message?: string;
  body?: { code?: string; message?: string } | null;
};

const UNIQUE_VIOLATION = "23505";
const INSUFFICIENT_PRIVILEGE = "42501";

/** The operator-facing reason a Create agency insert failed. */
export const createAgencyErrorMessage = (
  error: unknown,
  slug: string,
): string => {
  const failure = (
    typeof error === "object" && error !== null ? error : {}
  ) as PostgrestHttpError;
  const reason = failure.body?.message ?? failure.message ?? String(error);
  const code = failure.body?.code;

  if (code === UNIQUE_VIOLATION || /duplicate|unique/i.test(reason)) {
    return `The slug "${slug}" is already taken.`;
  }
  if (failure.status === 403 || code === INSUFFICIENT_PRIVILEGE) {
    return `Supabase refused to create the agency, so nothing was saved (${reason}). Send this message to the tech team.`;
  }
  return `Could not create the agency: ${reason}`;
};
